import React from 'react';
import logoImg from '../assets/images/logo.jpg';

// Official Alhilal First logo. The source file has a white background,
// so `chip` wraps it in a white circular badge when placed on a dark section.
export default function Logo({ size = 40, chip = false }) {
  const img = (
    <img
      src={logoImg}
      alt="Alhilal First logo"
      width={size}
      height={size}
      style={{ borderRadius: '50%', display: 'block', objectFit: 'cover' }}
    />
  );

  if (!chip) return img;

  const pad = Math.round(size * 0.12);
  return (
    <span
      style={{
        display: 'inline-flex',
        background: '#ffffff',
        borderRadius: '50%',
        padding: pad,
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      }}
    >
      {img}
    </span>
  );
}
